module.exports = __webpack_public_path__ + "static/media/3-react-d3-thumb.1dc08575.png";